import { ref, computed, type Ref } from 'vue'
import { sdk } from '@/graphql/client'

export interface Device {
    id: number
    name: string
    username: string
}

export interface DeviceFilters {
    search: string
}

function normalize(s: string): string {
    return s.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()
}

export function useDevicesData() {
    const devices: Ref<Device[]> = ref([])
    const loading = ref(false)
    const error = ref<string | null>(null)

    const filters: Ref<DeviceFilters> = ref({
        search: ''
    })

    async function refetch() {
        loading.value = true
        error.value = null
        try {
            const r = await sdk.AdminDevicesList()
            devices.value = (r.admin?.device?.list ?? []) as Device[]
        } catch (e) {
            error.value = (e as Error).message
            devices.value = []
        } finally {
            loading.value = false
        }
    }

    const filteredDevices = computed<Device[]>(() => {
        const q = filters.value.search ? normalize(filters.value.search) : ''

        const filtered = devices.value.filter(d => {
            if (!q) return true
            return normalize(d.name).includes(q) || normalize(d.username).includes(q)
        })

        return filtered.slice().sort((a, b) => a.name.localeCompare(b.name, 'cs'))
    })

    return { devices, filters, filteredDevices, loading, error, refetch }
}
